import { render, staticRenderFns } from "./notokensale.vue?vue&type=template&id=6017a296&"
import script from "./notokensale.vue?vue&type=script&lang=js&"
export * from "./notokensale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports